<!--<c-header class="mb-4 d-print-none" position="sticky">-->
  <ng-container>
    <c-container [fluid]="true" class="border-bottom px-4">
      <button
        [cSidebarToggle]="sidebarId()"
        cHeaderToggler
        class="btn"
        toggle="visible"
        style="margin-inline-start: -14px;"
        aria-label="Toggle sidebar navigation"
      >
        <svg cIcon name="cilMenu" size="lg"></svg>
      </button>
  
      <c-header-nav class="d-none d-md-flex ms-auto ">
        <c-nav-item style="display:flex; align-items:center">
          <c-dropdown variant="nav-item">
            <button cDropdownToggle cNavLink>
              {{ getSelectedApplicationName() }}
            </button>
            <ul cDropdownMenu>
              @for (application of applicationsService.applications; track application.id) {
                <li>
                  <button cDropdownItem (click)="selectApplication(application.id)">
                    {{ application.name }}
                  </button>
                </li>
              }
            </ul>
          </c-dropdown>
        </c-nav-item>
        <c-nav-item style="margin:auto">
            | &nbsp; {{ getCurrentUserEmail() }}
        </c-nav-item>
        <c-nav-item style="display:flex; align-items:center">
          <a cNavLink (click)="logout()">
            <svg cIcon class="my-1" name="cilAccountLogout" size="lg"></svg>
          </a>
        </c-nav-item>
      </c-header-nav>
    </c-container>
    <c-container [fluid]="true" class="px-4">
      <c-breadcrumb-router />
    </c-container>
  </ng-container>
  <!--</c-header>-->